import { render, staticRenderFns } from "./ress.vue?vue&type=template&id=5edb07bc&scoped=true&"
import script from "./ress.vue?vue&type=script&lang=js&"
export * from "./ress.vue?vue&type=script&lang=js&"
import style0 from "./ress.vue?vue&type=style&index=0&id=5edb07bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb07bc",
  null
  
)

export default component.exports